import {
  FETCH_ALL_RECIPE_PRODUCTS,
  RESET_RECIPE_PRODUCTS,
  REMOVE_RECIPE_PRODUCT,
  ADD_RECIPE_PRODUCT,
} from '../../mutation-types';

export default {
  [RESET_RECIPE_PRODUCTS](state) {
    state.all = [];
  },

  [FETCH_ALL_RECIPE_PRODUCTS](state, recipeProducts) {
    state.all = recipeProducts;
  },

  [REMOVE_RECIPE_PRODUCT](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_RECIPE_PRODUCT](state, recipeProduct) {
    state.all.push(recipeProduct);
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeProduct/mutations.js